import { Asset } from "./asset.class";
import { DealDashboardDetails } from "./deal-dashboard-details.class";
import { KeyValuePair } from "./key-value-pair.class";
import { Widget } from "./widget.class";
import { CoInvestmentDashboard } from "./co-investment-dashboard.class";

export class DealDashboard {
    summary!: DealDashboardDetails;
    widgets!: Record<Widget, KeyValuePair<string | number, number>[]>;
    assets!: Asset[];
    coInvestmentCaseStudy!: CoInvestmentDashboard;
    otherCountryNames!: string[];
}
